"use strict";

var _interopRequireDefault = require("/www/wwwroot/check/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _slicedToArray2 = _interopRequireDefault(require("/www/wwwroot/check/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
var _typeof2 = _interopRequireDefault(require("/www/wwwroot/check/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
var _LineChart = _interopRequireDefault(require("@/components/charts/LineChart.vue"));
var _BarChart = _interopRequireDefault(require("@/components/charts/BarChart.vue"));
var _doughnutChart = _interopRequireDefault(require("@/components/charts/doughnutChart.vue"));
var _GaugeChart = _interopRequireDefault(require("@/components/charts/GaugeChart1.vue"));
var _GaugeChart2 = _interopRequireDefault(require("@/components/charts/GaugeChart2.vue"));
var _reportTable = _interopRequireDefault(require("@/components/Widget/reportTable.vue"));
var _yuqiTable = _interopRequireDefault(require("@/components/Widget/yuqiTable.vue"));
var _yuqiTable2 = _interopRequireDefault(require("@/components/Widget/yuqiTable1.vue"));
var _jiaoyiTable = _interopRequireDefault(require("@/components/Widget/jiaoyiTable.vue"));
var _jiaoyiTable2 = _interopRequireDefault(require("@/components/Widget/jiaoyiTable1.vue"));
var _jiaoyiTable3 = _interopRequireDefault(require("@/components/Widget/jiaoyiTable2.vue"));
var _huankuanTable = _interopRequireDefault(require("@/components/Widget/huankuanTable.vue"));
var _jiekuanTable = _interopRequireDefault(require("@/components/Widget/jiekuanTable.vue"));
var _default2 = exports.default = {
  name: 'FengkongDefaultReportNew',
  props: {
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    member: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pieChart1: [],
      pieChart2: []
    };
  },
  components: {
    LineChart: _LineChart.default,
    GaugeChart1: _GaugeChart.default,
    GaugeChart2: _GaugeChart2.default,
    reportTable: _reportTable.default,
    yuqiTable: _yuqiTable.default,
    yuqiTable1: _yuqiTable2.default,
    BarChart: _BarChart.default,
    doughnutChart: _doughnutChart.default,
    jiaoyiTable: _jiaoyiTable.default,
    jiaoyiTable1: _jiaoyiTable2.default,
    jiaoyiTable2: _jiaoyiTable3.default,
    huankuanTable: _huankuanTable.default,
    jiekuanTable: _jiekuanTable.default
  },
  computed: {
    // 获取在网时长的显示内容
    onlineTimeDisplay: function onlineTimeDisplay() {
      if (Array.isArray(this.data.online_time) && this.data.online_time.length === 0) {
        return '暂无数据';
      }
      var state = this.data.online_time && this.data.online_time.state;
      var stateMap = {
        '1': '6个月以内',
        '2': '6到12个月',
        '3': '12到24个月',
        '4': '24个月以上',
        '-1': '异常情况'
      };
      return stateMap[String(state)] || '暂无数据';
    },
    // 运营商（数据宝 three / online_time）
    operatorDisplay: function operatorDisplay() {
      var src = this.data.three_info && this.data.three_info.operator != null ? this.data.three_info : this.data.online_time;
      var op = src && src.operator;
      var map = {
        '1': '移动',
        '2': '联通',
        '3': '电信'
      };
      return map[String(op)] || (op != null && op !== '' ? String(op) : '暂无');
    },
    xhzwDisplay: function xhzwDisplay() {
      var src = this.data.three_info && this.data.three_info.is_xhzw != null ? this.data.three_info : this.data.online_time;
      var v = src && src.is_xhzw;
      if (v === '1' || v === 1) return '是';
      if (v === '0' || v === 0) return '否';
      return '暂无';
    },
    // 探针 result_code 文案（应诺尔 V10 文档）
    resultCodeLabel: function resultCodeLabel() {
      var code = this.tzcField('result_code');
      var map = {
        '1': '逾期未还款',
        '2': '正常履约',
        '3': '逾期又还款',
        '4': '无法确认'
      };
      return map[String(code)] || (code != null ? "\u72B6\u6001\u7801".concat(code) : '暂无数据');
    },
    operatorRealDisplay: function operatorRealDisplay() {
      var src = this.data.three_info && this.data.three_info.operator_real != null ? this.data.three_info : this.data.online_time;
      var v = src && src.operator_real;
      if (v === '1' || v === 1) return '是';
      if (v === '0' || v === 0) return '否';
      return v != null && v !== '' ? String(v) : '暂无';
    },
    courtHasCaseLabel: function courtHasCaseLabel() {
      var v = this.data.court_info && this.data.court_info.has_case;
      if (v === 'Y' || v === 'y' || v === true || v === 1 || v === '1') return '有案';
      if (v === 'N' || v === 'n' || v === false || v === 0 || v === '0') return '无案';
      if (this.fayuanall > 0) return '有案';
      return '未知';
    },
    courtCountStat: function courtCountStat() {
      var info = this.data.court_info || {};
      return info.count_stat && (0, _typeof2.default)(info.count_stat) === 'object' ? info.count_stat : {};
    },
    courtStatNumRows: function courtStatNumRows() {
      var s = this.courtCountStat;
      var keys = [['count_total', '案件总数'], ['count_jie_total', '已结案总数'], ['count_wei_total', '未结案总数'], ['count_yuangao', '原告总数'], ['count_beigao', '被告总数'], ['count_other', '第三人总数'], ['money_total', '涉案总金额'], ['money_jie_total', '已结案金额'], ['money_wei_total', '未结案金额'], ['money_yuangao', '原告金额'], ['money_beigao', '被告金额'], ['money_wei_percent', '未结案金额占比']];
      return keys.filter(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 1),
          k = _ref2[0];
        return s[k] !== undefined && s[k] !== null && s[k] !== '';
      }).map(function (_ref3) {
        var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
          k = _ref4[0],
          label = _ref4[1];
        return {
          key: k,
          label: label,
          value: s[k]
        };
      });
    },
    courtStatTextRows: function courtStatTextRows() {
      var s = this.courtCountStat;
      var keys = [['area_stat', '涉案地域分布'], ['ay_stat', '涉案案由分布'], ['larq_stat', '涉案时间分布'], ['jafs_stat', '结案方式分布']];
      return keys.filter(function (_ref5) {
        var _ref6 = (0, _slicedToArray2.default)(_ref5, 1),
          k = _ref6[0];
        return s[k] !== undefined && s[k] !== null && s[k] !== '';
      }).map(function (_ref7) {
        var _ref8 = (0, _slicedToArray2.default)(_ref7, 2),
          k = _ref8[0],
          label = _ref8[1];
        return {
          key: k,
          label: label,
          value: s[k]
        };
      });
    },
    courtStatRows: function courtStatRows() {
      return this.courtStatNumRows.concat(this.courtStatTextRows);
    },
    fayuanHitCards: function fayuanHitCards() {
      var _this = this;
      var labels = ['执行公告', '失信公告', '裁判文书', '法院公告', '曝光台', '开庭公告', '案件流程', '网贷黑名单'];
      var iconMap = {
        2: require('@/assets/images/report/fayuan-icon2.png'),
        3: require('@/assets/images/report/fayuan-icon3.png'),
        4: require('@/assets/images/report/fayuan-icon4.png'),
        5: require('@/assets/images/report/fayuan-icon5.png'),
        6: require('@/assets/images/report/fayuan-icon6.png'),
        7: require('@/assets/images/report/fayuan-icon7.png'),
        8: require('@/assets/images/report/fayuan-icon8.png'),
        9: require('@/assets/images/report/fayuan-icon9.png')
      };
      var icons = [2, 3, 4, 5, 6, 7, 8, 9];
      return labels.map(function (label, i) {
        return {
          label: label,
          iconSrc: iconMap[icons[i]],
          hit: Number(_this.fayuannum[i] || 0) > 0,
          count: Number(_this.fayuannum[i] || 0)
        };
      });
    },
    casesTreeFlat: function casesTreeFlat() {
      var tree = this.data.court_info && this.data.court_info.cases_tree;
      if (!tree || (0, _typeof2.default)(tree) !== 'object') return [];
      var catLabel = {
        implement: '执行',
        civil: '民事',
        criminal: '刑事',
        administrative: '行政',
        preservation: '保全',
        bankrupt: '破产'
      };
      var out = [];
      Object.keys(tree).forEach(function (cat) {
        var arr = tree[cat];
        if (!Array.isArray(arr)) return;
        arr.forEach(function (item) {
          if (!item || (0, _typeof2.default)(item) !== 'object') return;
          out.push({
            category: catLabel[cat] || cat,
            case_type: item.case_type || cat,
            n_ajbs: item.n_ajbs || '',
            c_ah: item.c_ah || item.case_no || '',
            n_jbfy: item.n_jbfy || '',
            d_larq: item.d_larq || '',
            n_ssdw: item.n_ssdw || ''
          });
        });
      });
      return out;
    },
    seqNoLines: function seqNoLines() {
      var nos = this.data.seqNos || {};
      var labels = {
        tzc: '探针C',
        unify: '全景雷达',
        court: '法院',
        apply_loan_c: '3C租赁',
        blacklist: '金融黑名单'
      };
      return Object.keys(labels).filter(function (k) {
        return nos[k];
      }).map(function (k) {
        return {
          key: k,
          label: labels[k],
          value: nos[k]
        };
      });
    },
    courtEmptyTip: function courtEmptyTip() {
      if (this.fayuanall > 0) return '';
      var err = this.data.channel_errors && this.data.channel_errors.court;
      if (err) return err;
      var info = this.data.court_info || {};
      if (info.empty_msg) return info.empty_msg;
      if (info.has_case === 'N' || info.hit === false) return '数据库未查得';
      return '暂无法院公开案件';
    },
    // 应诺尔映射后的案件带 category / n_ajbs
    isEnolfaxCourt: function isEnolfaxCourt() {
      var list = this.data.fayuan_list || {};
      return Object.keys(list).some(function (k) {
        var arr = list[k];
        return Array.isArray(arr) && arr.some(function (i) {
          return i && (i.category || i.n_ajbs);
        });
      });
    },
    courtFlatList: function courtFlatList() {
      var list = this.data.fayuan_list || {};
      var typeLabel = {
        zxgg: '执行',
        shixin: '失信',
        cpws: '裁判文书',
        fygg: '行政/公告',
        bgt: '曝光台/限高',
        ktgg: '保全/开庭',
        ajlc: '刑事/流程',
        wdhmd: '网贷黑名单'
      };
      var out = [];
      Object.keys(list).forEach(function (k) {
        (list[k] || []).forEach(function (item) {
          out.push(Object.assign({}, item, {
            _typeLabel: typeLabel[k] || item.category || k
          }));
        });
      });
      return out;
    },
    applyLoanFlagLabel: function applyLoanFlagLabel() {
      var info = this.data.applyLoanC_info || {};
      var flag = info.flag_applyloanc != null ? info.flag_applyloanc : info.result_detail && info.result_detail.flag_applyloanc;
      if (flag === '1' || flag === 1) return '有申请意向数据';
      if (flag === '0' || flag === 0) return '无申请意向数据';
      return '';
    },
    applyLoanSeqNo: function applyLoanSeqNo() {
      var info = this.data.applyLoanC_info || {};
      return info.seqNo || this.data.seqNos && this.data.seqNos.apply_loan_c || '';
    },
    blackIdCardSide: function blackIdCardSide() {
      var info = this.data.black_info || {};
      return info.idCardSide && (0, _typeof2.default)(info.idCardSide) === 'object' ? info.idCardSide : {};
    },
    blackMobileSide: function blackMobileSide() {
      var info = this.data.black_info || {};
      return info.mobileSide && (0, _typeof2.default)(info.mobileSide) === 'object' ? info.mobileSide : {};
    },
    hasBlackDetail: function hasBlackDetail() {
      return Object.keys(this.blackIdCardSide).length > 0 || Object.keys(this.blackMobileSide).length > 0;
    },
    blackDetailPanels: function blackDetailPanels() {
      var _this2 = this;
      var sides = [{
        key: 'idCard',
        title: '身份证维度',
        data: this.blackIdCardSide
      }, {
        key: 'mobile',
        title: '手机号维度',
        data: this.blackMobileSide
      }];
      return sides.map(function (side) {
        return {
          key: side.key,
          title: side.title,
          rows: [{
            label: '风险等级',
            value: _this2.blackLevelLabel(side.data.level),
            tone: _this2.blackLevelTone(side.data.level)
          }, {
            label: '最新逾期/欺诈状态',
            value: _this2.blackConditionLabel(side.data.lastCondition),
            tone: _this2.blackConditionTone(side.data.lastCondition)
          }, {
            label: '近12月最严重状态',
            value: _this2.blackConditionLabel(side.data.seriousCondition),
            tone: _this2.blackConditionTone(side.data.seriousCondition)
          }, {
            label: '贷款类型',
            value: _this2.blackLoanTypeLabel(side.data.loanTypes),
            tone: ''
          }, {
            label: '近6月黑名单机构数',
            value: side.data.blackOrgNum != null && side.data.blackOrgNum !== '' ? side.data.blackOrgNum : '-',
            tone: Number(side.data.blackOrgNum) > 0 ? 'tone-warn' : ''
          }]
        };
      });
    },
    // 用于图表展示
    jigoudata: function jigoudata() {
      return {
        tooltip: {
          trigger: 'item'
        },
        // legend: {
        //   orient: 'vertical',
        //   right: '10%', // 调整右边距
        //   top: 'middle',
        //   formatter: (name) => {
        //     // 在图例中找到对应的数据项
        //     const item = this.pieChart1.find(item => item.name === name);
        //     return `${name}: ${item ? item.value : 0}`;
        //   },
        //   textStyle: {
        //     fontSize: 14 // 调整字体大小
        //   }
        // },
        series: [{
          type: 'pie',
          radius: ['40%', '60%'],
          // 增大饼图半径
          center: ['35%', '50%'],
          // 调整中心位置
          label: {
            show: false,
            position: 'center'
          },
          // emphasis: {
          //   label: {
          //     show: true,
          //     fontSize: 20, // 调小强调时的字体
          //     fontWeight: 'bold'
          //   }
          // },
          data: this.pieChart1
        }]
      };
    },
    xiaojindata: function xiaojindata() {
      return {
        tooltip: {
          trigger: 'item'
        },
        series: [{
          type: 'pie',
          radius: ['60%', '80%'],
          // 增大饼图半径
          center: ['50%', '50%'],
          // 调整中心位置
          label: {
            show: false,
            position: 'center'
          },
          // emphasis: {
          //   label: {
          //     show: true,
          //     fontSize: 20, // 调小强调时的字体
          //     fontWeight: 'bold'
          //   }
          // },
          data: this.pieChart2
        }]
      };
    },
    // 法院数据统计
    fayuannum: function fayuannum() {
      var fayuanList = this.data.fayuan_list;
      return [fayuanList && fayuanList.zxgg ? fayuanList.zxgg.length : 0, fayuanList && fayuanList.shixin ? fayuanList.shixin.length : 0, fayuanList && fayuanList.cpws ? fayuanList.cpws.length : 0, fayuanList && fayuanList.fygg ? fayuanList.fygg.length : 0, fayuanList && fayuanList.bgt ? fayuanList.bgt.length : 0, fayuanList && fayuanList.ktgg ? fayuanList.ktgg.length : 0, fayuanList && fayuanList.ajlc ? fayuanList.ajlc.length : 0, fayuanList && fayuanList.wdhmd ? fayuanList.wdhmd.length : 0];
    },
    fayuanall: function fayuanall() {
      return this.fayuannum.reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
    },
    zxggData: function zxggData() {
      return this.data.fayuan_list && this.data.fayuan_list.zxgg || [];
    },
    shixinData: function shixinData() {
      return this.data.fayuan_list && this.data.fayuan_list.shixin || [];
    },
    cpwsData: function cpwsData() {
      return this.data.fayuan_list && this.data.fayuan_list.cpws || [];
    },
    fyggData: function fyggData() {
      return this.data.fayuan_list && this.data.fayuan_list.fygg || [];
    },
    bgtData: function bgtData() {
      return this.data.fayuan_list && this.data.fayuan_list.bgt || [];
    },
    ktggData: function ktggData() {
      return this.data.fayuan_list && this.data.fayuan_list.ktgg || [];
    },
    ajlcData: function ajlcData() {
      return this.data.fayuan_list && this.data.fayuan_list.ajlc || [];
    },
    wdhmdData: function wdhmdData() {
      return this.data.fayuan_list && this.data.fayuan_list.wdhmd || [];
    },
    applyLoanData: function applyLoanData() {
      var _this3 = this;
      var applyLoanC = this.data.applyLoanC_info && this.data.applyLoanC_info.ApplyLoanC || {};

      // 定义时间维度（对齐应诺尔 V18：含 d3/d14）
      var timeDimensions = ['d3', 'd7', 'd14', 'm1', 'm3', 'm6', 'm12'];

      // 定义需要的字段
      var fields = ['allnum', 'orgnum', 'weekend_allnum', 'weekend_orgnum', 'night_allnum', 'night_orgnum', 'tot_mons', 'avg_monnum', 'max_monnum', 'min_monnum'];
      var result = [];
      timeDimensions.forEach(function (time) {
        if (applyLoanC[time]) {
          var timeData = {
            time: _this3.getTimeLabel(time),
            // 时间标签，如 "近7天"
            allnum: '',
            orgnum: '',
            weekend_allnum: '',
            weekend_orgnum: '',
            night_allnum: '',
            night_orgnum: '',
            tot_mons: '',
            avg_monnum: '',
            max_monnum: '',
            min_monnum: ''
          };
          fields.forEach(function (field) {
            var idValue = applyLoanC[time].id && applyLoanC[time].id[field] ? applyLoanC[time].id[field] : '0';
            var cellValue = applyLoanC[time].cell && applyLoanC[time].cell[field] ? applyLoanC[time].cell[field] : '0';

            // 格式化为 "身份证查询次数/手机号查询次数"
            timeData[field] = "".concat(idValue, "/").concat(cellValue);
          });
          result.push(timeData);
        }
      });
      return result;
    },
    tableFields: function tableFields() {
      return [{
        key: 'allnum',
        label: '申请总次数'
      }, {
        key: 'orgnum',
        label: '申请总机构数'
      }, {
        key: 'weekend_allnum',
        label: '周末申请次数'
      }, {
        key: 'weekend_orgnum',
        label: '周末申请机构数'
      }, {
        key: 'night_allnum',
        label: '夜间申请次数'
      }, {
        key: 'night_orgnum',
        label: '夜间申请机构数'
      }, {
        key: 'tot_mons',
        label: '有申请记录月份数'
      }, {
        key: 'avg_monnum',
        label: '平均每月申请次数'
      }, {
        key: 'max_monnum',
        label: '最大月申请次数'
      }, {
        key: 'min_monnum',
        label: '最小月申请次数'
      }];
    }
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler: function handler() {
        this.refreshCharts();
      }
    }
  },
  methods: {
    refreshCharts: function refreshCharts() {
      this.pieChart1 = [{
        name: '当前逾期机构数',
        value: Number(this.tzcField('currently_overdue') || 0),
        itemStyle: {
          color: '#FF6D6D'
        }
      }, {
        name: '当前履约机构数',
        value: Number(this.tzcField('currently_performance') || 0),
        itemStyle: {
          color: '#66B2FE'
        }
      }, {
        name: '异常还款机构数',
        value: Number(this.tzcField('acc_exc') || 0),
        itemStyle: {
          color: '#FEC14D'
        }
      }, {
        name: '睡眠机构数',
        value: Number(this.tzcField('acc_sleep') || 0),
        itemStyle: {
          color: '#ACACAC'
        }
      }];
      this.pieChart2 = [{
        name: '网络贷款机构数',
        value: this.getRiskValue1(['unify_info', 'current_report_detail', 'C22180003']),
        itemStyle: {
          color: '#4D7CFE'
        }
      }, {
        name: '网络贷款类产品数',
        value: this.getRiskValue1(['unify_info', 'current_report_detail', 'C22180004']),
        itemStyle: {
          color: '#42D3C0'
        }
      }, {
        name: '消金贷款类机构数',
        value: this.getRiskValue1(['unify_info', 'current_report_detail', 'C22180007']),
        itemStyle: {
          color: '#93B1FF'
        }
      }, {
        name: '消金贷款类产品数',
        value: this.getRiskValue1(['unify_info', 'current_report_detail', 'C22180008']),
        itemStyle: {
          color: '#8AE4D3'
        }
      }];
    },
    // 获取时间维度的标签
    getTimeLabel: function getTimeLabel(timeKey) {
      var labels = {
        'd3': '近3天',
        'd7': '近7天',
        'd14': '近14天',
        'm1': '近1月',
        'm3': '近3月',
        'm6': '近6月',
        'm12': '近12月'
      };
      return labels[timeKey] || timeKey;
    },
    blackLevelLabel: function blackLevelLabel(level) {
      var map = {
        '0': '未命中',
        '1': '轻微逾期',
        '2': '一般逾期',
        '3': '严重逾期',
        '4': '关联风险',
        '5': '疑似欺诈',
        '6': '欺诈'
      };
      if (level === undefined || level === null || level === '') return '-';
      return map[String(level)] || String(level);
    },
    blackLevelTone: function blackLevelTone(level) {
      var n = Number(level);
      if (level === undefined || level === null || level === '' || n === 0) return 'tone-ok';
      if (n <= 2) return 'tone-warn';
      return 'tone-danger';
    },
    blackConditionTone: function blackConditionTone(code) {
      if (!code) return '';
      var c = String(code);
      if (c === 'fraud' || c === 'suspected_fraud' || c.indexOf('Related') === 0 || c === 'M6+' || c === 'M6' || c === 'M5' || c === 'M4') {
        return 'tone-danger';
      }
      if (c === 'M1' || c === 'M2' || c === 'M3') return 'tone-warn';
      return '';
    },
    blackConditionLabel: function blackConditionLabel(code) {
      var map = {
        'M1': 'M1 逾期1-30天（轻微）',
        'M2': 'M2 逾期31-60天（一般）',
        'M3': 'M3 逾期61-90天（一般）',
        'M4': 'M4 逾期91-120天（严重）',
        'M5': 'M5 逾期121-150天（严重）',
        'M6': 'M6 逾期151-180天（严重）',
        'M6+': 'M6+ 逾期181天及以上（严重）',
        'Related risks': '关联风险',
        'Related risk': '关联风险',
        'suspected_fraud': '疑似欺诈',
        'fraud': '欺诈'
      };
      if (!code) return '-';
      return map[String(code)] || String(code);
    },
    blackLoanTypeLabel: function blackLoanTypeLabel(code) {
      var map = {
        payday_loan: '发薪日贷款',
        micro_loan: '小额贷款',
        p2p: 'P2P',
        cf_edu: '消费金融-教育',
        cf_medical: '消费金融-医美',
        cf_rent: '消费金融-租房',
        cf_digital: '消费金融-数码',
        cf_car: '消费金融-买车',
        cf_deco: '消费金融-装修',
        cf_tour: '消费金融-旅游',
        cf_agri: '消费金融-农业',
        cf_others: '消费金融-其他',
        supply_chain: '供应链金融',
        leasing_company: '融资租赁',
        car_mortgage: '车辆抵押贷款',
        house_mortgage: '房贷',
        credit_card: '信用卡',
        balance_transfer: '信用卡代偿',
        others: '其他',
        IOU: '借条'
      };
      if (!code) return '-';
      return map[String(code)] || String(code);
    },
    tzcField: function tzcField(key) {
      var info = this.data && this.data.tzc_info;
      if (!info || (0, _typeof2.default)(info) !== 'object') return null;
      var v = info[key];
      return v === undefined || v === null || v === '' ? null : v;
    },
    tableRowStyle: function tableRowStyle(_ref9) {
      var rowIndex = _ref9.rowIndex;
      if (rowIndex % 2 === 1) {
        // 偶数行（索引从0开始，所以1是第2行）
        return {
          backgroundColor: '#E7EDFF'
        };
      }
      return {};
    },
    // 通用方法，根据 riskValue 和映射对象返回结果
    formatRiskRange: function formatRiskRange(riskValue, cases) {
      riskValue = isNaN(Number(riskValue)) ? 0 : Number(riskValue); // 确保是数字

      return cases[riskValue] || cases.default;
    },
    // 通用方法，根据路径参数返回结果
    getRiskRange: function getRiskRange(path, cases) {
      var riskValue = this.getRiskValue(path);
      return this.formatRiskRange(riskValue, cases);
    },
    getRiskValue: function getRiskValue(fields) {
      // 递归获取数据
      var source = this.data;
      for (var value in fields) {
        // 判断是否为数组
        var field = fields[value];
        // 判断是否为数组
        if (source && source.hasOwnProperty(field)) {
          source = source[field];
        } else {
          source = '-';
        }
      }
      return source;
    },
    getRiskValue1: function getRiskValue1(fields) {
      // 递归获取数据
      var source = this.data;
      for (var value in fields) {
        // 判断是否为数组
        var field = fields[value];
        // 判断是否为数组
        if (source && source.hasOwnProperty(field)) {
          source = source[field];
        } else {
          source = 0;
        }
      }
      return source;
    },
    customColorMethod: function customColorMethod(percentage) {
      // 红色
      if (percentage < 30) {
        return '#f56c6c';
      }
      // 黄色
      if (percentage < 70) {
        return '#e6a23c';
      }
      // 绿色
      if (percentage < 90) {
        return '#67c23a';
      }

      // 默认灰色
      return '#909399';
    },
    getQyToday: function getQyToday(daynum) {
      switch (daynum) {
        case 1:
          return '0~7';
        case 2:
          return '7~15';
        case 3:
          return '15~30';
        case 4:
          return '30~60';
        case 5:
          return '60~90';
        case 6:
          return '90~120';
        case 7:
          return '120~150';
        case 8:
          return '150~180';
        case 9:
          return '180~360';
        case 10:
          return '360以上';
        default:
          return '-1';
      }
    },
    customColorMethod1: function customColorMethod1(percentage) {
      // 绿色
      if (percentage < 30) {
        return '#01c2a1';
      }
      // 黄色
      if (percentage < 70) {
        return '#feba01';
      }
      // 红色
      if (percentage < 90) {
        return '#f12021';
      }

      // 默认灰色
      return '#909399';
    }
  }
};